import { buildSerializer, buildDeserializer } from "lib/serializerUtils";

const attachmentSerializeMap = {
  consignment: "consignment",
  deploymentSale: "deployment_sale",
  id: "id",
  envdId: "envd_id",
  image_url: "image_url",
  latestParseResultStatus: "latest_parse_result_status",
  livestock_sale: "livestock_sale",
  order: "order",
  sale_lot: "sale_lot",
  thumbnail_url: "thumbnail_url",
  type: "type",
};

export const deserializeAttachment = buildDeserializer(
  attachmentSerializeMap,
  "attachment",
);

export const serializeAttachment = buildSerializer(
  attachmentSerializeMap,
  "attachment",
);
